import Select from "../../../../form/Select";
import React, {Fragment} from "react";
import isEqual from "lodash-es/isEqual";
import {AddressFormatter, optionsTemplate} from "../../../../../utils/formatters";

export class Target extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        const propsTop = {...this.props};
        const {props} = propsTop;
        const prevPropsTop = {...prevProps};
        const pProps = prevPropsTop.props;
        if (isEqual(props.values.id + "", (pProps || {}).id + "") && !isEqual((props.values.customer || {}).partner_id, (((pProps || {}).values.customer) || {}).partner_id)) {
            props.setFieldValue("target", null);
        }
    }

    render() {
        const propsTop = {...this.props};
        const {props, state, parent} = propsTop;
        const {hidden, labels} = props;
        return (hidden || []).indexOf("target") === -1 && (!!props.values.customer || this.props.visible) ? <Select
            label={labels.target || "Hova"}
            name="target"
            component="location"
            objectValue={true}
            labelKey="name"
            storeType="bound"
            boundField={this.props.boundField || "partner"}
            boundValue={props.values.customer && props.values.customer.partner_id}
            optionsTemplate={optionsTemplate("location")}
            {...props.getProps("target")}
            value={props.getValue("target")}
            saveChanges={props.setFieldValue}
        /> : null;
    }
}

export default Target;